import { FC } from 'react';
import { Button } from '@carbon/react';
import { SettingsAdjust } from '@carbon/react/icons';
import wellStyles from './wells.module.scss';

// The Well-section analogue of StructuredParties' NoMatchCard. Shown in the
// matches strip when the Well Matching Agent returned no confident candidate
// (a no-match sentinel, excluded from `suggestions` server-side) — instead of
// the misleading all-'—' / 0% dummy suggestion tile.

interface Props {
  /** Opens Change Match. Omitted (CTA hidden) when the row is reviewed/removed. */
  onChangeMatch?: () => void;
}

export const WellNoMatchCard: FC<Props> = ({ onChangeMatch }) => (
  <div className={wellStyles.noMatchCard}>
    <div className={wellStyles.noMatchTitle}>No match found</div>
    <p className={wellStyles.noMatchBody}>
      The agent did not find a confident match for this extracted well. Use
      Change Match to search the well database, or create an imported well.
    </p>
    {onChangeMatch && (
      <div className={wellStyles.noMatchActions}>
        <Button
          kind="primary"
          size="sm"
          renderIcon={SettingsAdjust}
          onClick={onChangeMatch}
        >
          Change Match
        </Button>
      </div>
    )}
  </div>
);
